$(function () {
    const notice = document.getElementById('cookieNotice');
    const acceptButton = document.getElementById('cookieAccept');

    if (!localStorage.getItem('cookieAccepted')) {
        notice.style.display = 'block';
    }

    acceptButton.addEventListener('click', () => {
        localStorage.setItem('cookieAccepted', 'true');
        notice.style.display = 'none';
    });
})